import React from "react";

const Stat_T_Table = () => {
  return (
    <div>
      <h1>Stat T-Table</h1>
    </div>
  );
};

export default Stat_T_Table;
